/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Mission_TitleInputs */

const en_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Mission`)
};

const de_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Mission`)
};

const fr_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre mission`)
};

const es_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra mision`)
};

const it_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nostra missione`)
};

const nl_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze missie`)
};

const pl_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasza misja`)
};

const fi_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävämme`)
};

const da_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores mission`)
};

const sv_about_mission_title = /** @type {(inputs: About_Mission_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vart uppdrag`)
};

/**
* | output |
* | --- |
* | "Our Mission" |
*
* @param {About_Mission_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_mission_title = /** @type {((inputs?: About_Mission_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Mission_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_mission_title(inputs)
	if (locale === "fr") return fr_about_mission_title(inputs)
	if (locale === "es") return es_about_mission_title(inputs)
	if (locale === "it") return it_about_mission_title(inputs)
	if (locale === "nl") return nl_about_mission_title(inputs)
	if (locale === "pl") return pl_about_mission_title(inputs)
	if (locale === "fi") return fi_about_mission_title(inputs)
	if (locale === "da") return da_about_mission_title(inputs)
	if (locale === "sv") return sv_about_mission_title(inputs)
	return en_about_mission_title(inputs)
});